import React, { useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Plus, Pencil, Trash2, X } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';

const ICONS = ['BookOpen', 'BarChart3', 'Cloud', 'GitBranch', 'Code2', 'Database', 'Shield', 'Brain', 'TrendingUp', 'Target', 'CheckCircle2', 'Link2', 'Bot'];

export default function AdminCategories() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(null);
  const { toast } = useToast();
  const load = () => api.categories().then(setRows);
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (form.id_orig) await api.admin.categoryUpdate(form.id_orig, { name: form.name, icon: form.icon, count: Number(form.count) });
      else await api.admin.categoryCreate({ name: form.name, icon: form.icon, count: Number(form.count) });
      toast({ title: form.id_orig ? 'Updated' : 'Created' });
      setForm(null); load();
    } catch (e) { toast({ title: 'Failed', variant: 'destructive' }); }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this category?')) return;
    await api.admin.categoryDelete(id);
    toast({ title: 'Deleted' });
    load();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-extrabold">Categories</h1>
          <p className="text-gray-500 text-sm mt-1">{rows.length} categories</p>
        </div>
        <Button onClick={() => setForm({ name: '', icon: 'BookOpen', count: 0 })} className="bg-[#6b47dc] hover:bg-[#5a3ac0]"><Plus size={16} className="mr-1" /> Add category</Button>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {rows.map(r => (
          <div key={r.id} className="bg-white rounded-2xl border border-gray-200 p-5">
            <div className="flex items-start justify-between mb-2">
              <div>
                <div className="font-bold text-lg">{r.name}</div>
                <div className="text-xs text-gray-500 mt-1">Icon: <span className="font-mono">{r.icon}</span> • {r.count} courses</div>
              </div>
              <div className="flex gap-1">
                <button onClick={() => setForm({ ...r, id_orig: r.id })} className="p-1.5 text-[#6b47dc] hover:bg-purple-50 rounded"><Pencil size={14} /></button>
                <button onClick={() => remove(r.id)} className="p-1.5 text-red-600 hover:bg-red-50 rounded"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {form && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setForm(null)}>
          <div className="bg-white rounded-2xl max-w-md w-full" onClick={(e) => e.stopPropagation()}>
            <div className="p-5 border-b border-gray-100 flex items-center justify-between">
              <h3 className="font-extrabold text-lg">{form.id_orig ? 'Edit category' : 'New category'}</h3>
              <button onClick={() => setForm(null)}><X size={18} /></button>
            </div>
            <div className="p-5 space-y-3">
              <div><label className="text-xs font-bold text-gray-500">Name</label><input className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
              <div><label className="text-xs font-bold text-gray-500">Icon</label>
                <select className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })}>{ICONS.map(i => <option key={i}>{i}</option>)}</select>
              </div>
              <div><label className="text-xs font-bold text-gray-500">Course count</label><input type="number" className="w-full px-3 py-2 rounded-lg border border-gray-200 outline-none focus:border-[#6b47dc]" value={form.count} onChange={(e) => setForm({ ...form, count: e.target.value })} /></div>
            </div>
            <div className="p-5 border-t border-gray-100 flex justify-end gap-2">
              <Button variant="outline" onClick={() => setForm(null)}>Cancel</Button>
              <Button onClick={save} className="bg-[#6b47dc] hover:bg-[#5a3ac0]">Save</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
